<page-grid [gridConfig]="clientBalanceGrid" (gridClickColumn)="handleItemClick($event)"/>
